export const PWA_BASE_URL = 'https://pwa.touchsource.com/';

// The system's top-level component: the last `component.` key under the
// system, the same pick Systems.js uses for previews and screenshots.
export const getSystemTLCUUID = (fd, systemUUID) => {
	let tlcUUID = '';
	for (const m2Key of Object.keys(fd?.[`system.${systemUUID}`] || {})) {
		if (m2Key.startsWith('component.')) {
			tlcUUID = m2Key.split('.')[1];
		}
	}
	return tlcUUID;
};

// null without a component: a condor_component-less link loads nothing
export const getPWAURL = (tlcUUID) => {
	if (!tlcUUID) {
		return null;
	}
	return `${PWA_BASE_URL}?condor_component=${encodeURIComponent(tlcUUID)}`;
};

export const PWA_NO_COMPONENT_TEXT = 'No component assigned';

// navigator.clipboard is undefined in insecure contexts / older browsers, and
// touching .writeText there throws synchronously — reject instead so callers
// handle both failure modes in one .catch.
export const copyTextToClipboard = (text) => {
	if (!navigator.clipboard || !navigator.clipboard.writeText) {
		return Promise.reject(new Error('Clipboard API unavailable'));
	}
	return navigator.clipboard.writeText(text);
};
